import { Box, Grid, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Upload,
} from '@mui/icons-material';
import './index.scss';
import getBase64 from '../../../helper/images';
import { setAlertDescription } from '../../../hooks/actions';

const DropZone = (props: any) => {
  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    let namesFilesError = '';

    fileRejections.map((errorFile: any) => {
      namesFilesError = namesFilesError !== '' ? `${namesFilesError}, ${errorFile?.file?.name}` : errorFile?.file?.name
    })

    if (fileRejections.length > 0) {
      setAlertDescription({
        open: true,
        message: `The following files cannot be uploaded, exceeded the size limit (${namesFilesError}), the others files were uploaded`,
        severity: 'warning',
      })
    }

    acceptedFiles.map((file: any) => {
      getBase64(file)
        .then(async (data) => {
          try {
            const { name, size } = file;
            props.handleZone('file', { base64: data, name, size }, namesFilesError);
          } catch (e: any) {
            console.error(e);
          }
        });
    })
  }, []);

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: 'image/jpeg, image/png, application/pdf',
    multiple: true,
    maxFiles: 10,
    maxSize: 26214400,
    onDrop,
  });

  const baseStyle = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 15,
    borderColor: '#A5A5A5',
    borderStyle: 'dashed',
    backgroundColor: '#EAEAEA',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    minHeight: '120px',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {}),
  }), [
    isFocused,
    isDragAccept,
    isDragReject,
  ]);

  return (
    <Grid
      sx={{
        width: '100%',
        height: '10%',
        cursor: 'pointer',
      }}
      {...getRootProps({ style, className: `dropzone dropzone-container` })}
    >
      <input {...getInputProps()} />
      <Grid container className='grid-container'>
        <Grid item xs={3} alignItems="center">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <Upload fontSize="large" sx={{ color: 'black' }} />
          </Box>
        </Grid>
        <Grid item xs={9}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Typography
              component="p"
              variant="h2"
              sx={{
                fontWeight: 500,
              }}
            >
              Upload Files
            </Typography>
            <Typography
              component="p"
              variant="body1"
              sx={{
                padding: '2% 2% 0 0',
                fontSize: '14px',
                fontWeight: 300,
              }}
            >
              Drag and Drop files onto this windows or click to&nbsp;
              {<Typography
                component="span"
                variant="body1"
                sx={{
                  padding: '2% 2% 0 0',
                  fontSize: '14px',
                  color: '#feb100',
                  fontWeight: 500,
                }}
              >
                Browse
              </Typography>}
            </Typography>
            <Typography
              component="span"
              variant="body1"
              sx={{
                padding: '2% 2% 0 0',
                color: '#dc3545',
                fontSize: '10px',
                fontWeight: 500
              }}
            >
              Maximum Upload File size (25 MB)
            </Typography>
            <Typography
              component="span"
              variant="body1"
              sx={{
                fontSize: '10px',
                fontWeight: 500,
              }}
            >
              Supports: JPEG, PNG, PDF
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DropZone;
